import { IPhotoRevealsNormalized } from '../api/models/photoReveals/photoReveals.types';
import { ActionsUnion, createAction } from '../helpers';

export enum EPhotoRevealsActionType {
  GET = 'PHOTO_REVEALS/GET',
  GET_SUCCESS = 'PHOTO_REVEALS/GET_SUCCESS',
  RESET = 'PHOTO_REVEALS/RESET',
}

export const photoRevealsActions = {
  getPhotoReveals: (reset: boolean) =>
    createAction(EPhotoRevealsActionType.GET, { reset }),
  resetPhotoReveals: () => createAction(EPhotoRevealsActionType.RESET),
  getPhotoRevealsSuccess: (payload: IPhotoRevealsNormalized) =>
    createAction(EPhotoRevealsActionType.GET_SUCCESS, payload),
};

export type TPhotoRevealsActions = ActionsUnion<typeof photoRevealsActions>;
